module.exports = __webpack_public_path__ + "img/edge_filter_meta.4e127f55.jpg";